import SystemValueList from "../../../../components/SystemValue/SystemValueList";
import { formatTaxValue, taxTypeLabel } from "./taxFormat";

const COLUMNS = [
  { header: "Name", render: (t) => t.name || "—" },
  { header: "Type", render: (t) => taxTypeLabel(t.type) },
  { header: "Value", render: formatTaxValue },
];

const TaxList = ({ taxes, canEdit, onEdit, onDelete }) => (
  <SystemValueList
    items={taxes}
    columns={COLUMNS}
    onEdit={onEdit}
    onDelete={onDelete}
    showStatus={false}
    showActions={canEdit}
    emptyMessage="No taxes added yet."
  />
);

export default TaxList;